const cCConfig = {
  autorun: true,
  delay: 0,
  current_lang: 'ca',
  autoclear_cookies: true,
  cookie_expiration: 365,
  page_scripts: true,

  languages: {
    ca: {
      consent_modal: {
        title: 'Cookies en aquesta web 🍪',
        description: `La Federació Catalana de Pàdel utilitza cookies pròpies i de tercers per al seu funcionament bàsic i per a fins analítics. Cliqueu <a target="_blank" href="/cookies"><b>aquí</b></a> per a més informació. Pots acceptar totes les cookies prement el botó "Acceptar" o configurar-les prement el botó "Configuració".`,
        primary_btn: {
          text: 'Acceptar',
          role: 'accept_all' //'accept_selected' or 'accept_all'
        },
        secondary_btn: {
          text: 'Configuració',
          role: 'settings' //'settings' or 'accept_necessary'
        }
      },
      settings_modal: {
        title: '<div>Configuració de cookies</div>',
        save_settings_btn: 'Guardar configuració',
        accept_all_btn: 'Acceptar totes',
        close_btn_label: 'Tancar',
        cookie_table_headers: [
          { col1: 'Nom' },
          { col2: 'Domini' },
          { col3: 'Caducitat' },
          { col4: 'Finalitat' }
        ],
        blocks: [
          {
            title: 'Panel de configuració',
            description: `Pots activar o desactivar els diferents tipus de cookies quan vulguis. Per a més informació sobre les cookies, visiteu la pàgina de <a target="_blank" href="/cookies">política de cookies</a>`
          },
          {
            title: 'Cookies estrictament necessàries',
            description:
              "Aquestes cookies són essencials per al correcte funcionament d'aquest lloc web. Sense aquestes cookies, el lloc web no funcionaria correctament",
            toggle: {
              value: 'necessary',
              enabled: true,
              readonly: true //cookie categories with readonly=true are all treated as "necessary cookies"
            }
          },
          // {
          //   title: 'Cookies de preferència',
          //   description:
          //     'Aquestes cookies permeten que el lloc web recordi les eleccions que has realitzat en el passat',
          //   toggle: {
          //     value: 'preferences', //there no default categories => you specify them
          //     enabled: false,
          //     readonly: false
          //   },
          //   cookie_table: [
          //     {
          //       col2: 'fcpadel.cat',
          //       col3: '5 minuts',
          //       col4: 'Recordar llenguatge elegit'
          //     }
          //   ]
          // },
          {
            title: `Cookies d'anàlisi`,
            description:
              'Aquestes cookies recopilen informació sobre com utilitza el lloc web, quines pàgines va visitar i en quins enllaços va fer clic. Totes les dades són anonimitzades i no es poden utilitzar per identificar-lo.',
            toggle: {
              value: 'analytics',
              enabled: false,
              readonly: false
            },
            cookie_table: [
              {
                col1: '_ga',
                col2: 'google.com',
                col3: '6 mesos',
                col4: 'Diferenciar usuaris',
                col5: 'Permanent'
              },
              {
                col1: '_gat',
                col2: 'google.com',
                col3: '1 minut',
                col4: 'Limitar el percentatge de sol·licituds',
                col5: 'Permanent'
              },
              {
                col1: '_gid',
                col2: 'google.com',
                col3: '1 dia',
                col4: 'Diferenciar usuaris',
                col5: 'Permanent'
              }
            ]
          }
        ]
      }
    }
  }
}

export default cCConfig
